import { render, staticRenderFns } from "./BulkOrderCardDesignsIndexPage.vue?vue&type=template&id=644ead81&scoped=true&"
import script from "./BulkOrderCardDesignsIndexPage.vue?vue&type=script&lang=js&"
export * from "./BulkOrderCardDesignsIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./BulkOrderCardDesignsIndexPage.vue?vue&type=style&index=0&id=644ead81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ead81",
  null
  
)

export default component.exports